import type { Translation } from '../types.ts';
import type en from '../en/faq.ts';

export default {
    shared: {
        noCategory: 'Geen categorie',
        addQuestion: 'Vraag toevoegen',
    },
    index: {
        title: 'FAQ',
        description: 'Vragen gegroepeerd in categorieën. Elke categorie krijgt een eigen pagina op {path}, en elke vraag heeft een eigen vaste link, zodat je direct naar een antwoord kunt verwijzen.',
        defaultLocale: '(standaard)',
        localeNote: 'Elke taal heeft zijn eigen vragen. Er wordt niets tussen talen gekopieerd.',
        newCategory: 'Nieuwe categorie',
        newCategoryPlaceholder: 'Verzending',
        categories: 'Categorieën',
        noCategories: 'Geen categorieën in deze taal. Vragen kunnen ook zonder categorie.',
        noQuestionsHidden: 'Nog geen vragen: niet zichtbaar op de site',
        unpublishedHidden: 'Niet gepubliceerd: niet zichtbaar op de site',
        deleteCategory: 'Categorie verwijderen',
        confirmDeleteCategory: '“{name}” verwijderen? | “{name}” verwijderen? De vraag erin gaat naar “Geen categorie” en verschijnt op de FAQ-overzichtspagina. | “{name}” verwijderen? De {n} vragen erin gaan naar “Geen categorie” en verschijnen op de FAQ-overzichtspagina.',
        confirmDeleteQuestion: '“{question}” verwijderen?',
        uncategorisedNote: 'Deze vragen hebben geen categorie en staan direct op de FAQ-overzichtspagina.',
        intro: 'Inleiding',
        introHint: 'Optionele zin boven de vragen. Platte tekst.',
        publishedHint: 'Uitzetten verbergt de categorie en alle vragen erin.',
        emptyUncategorised: 'Geen losse vragen. Voeg er hier een toe en die verschijnt op de FAQ-overzichtspagina, zonder categorie.',
        emptyCategory: 'Nog geen vragen in deze categorie. Een categorie zonder gepubliceerde vragen wordt helemaal niet op de site getoond.',
        pickCategory: 'Kies een categorie, of voeg er een toe, om vragen te schrijven.',
    },
    dialog: {
        newTitle: 'Nieuwe vraag',
        editTitle: 'Vraag bewerken',
        question: 'Vraag',
        questionPlaceholder: 'Hoe lang duurt de levering?',
        questionHint: 'Schrijf de vraag zoals een bezoeker hem zou stellen, niet als zoekwoorden.',
        category: 'Categorie',
        categoryHint: 'Optioneel. Zonder categorie verschijnt de vraag op de FAQ-overzichtspagina.',
        answer: 'Antwoord',
        answerNote: 'Schrijf een antwoord dat op zichzelf staat. Zoekmachines en AI-assistenten citeren steeds één vraag met antwoord, los van de pagina, dus “zoals hierboven vermeld” zegt de lezer niets.',
        publishNote: 'Een vraag kan niet gepubliceerd worden zolang het antwoord leeg is. Sla hem ongepubliceerd op om verder te schrijven.',
        showAnchor: 'Linkanker tonen',
        hideAnchor: 'Linkanker verbergen',
        anchor: 'Anker',
        anchorNote: 'Links die mensen al gedeeld hebben, verwijzen naar {anchor}. Als je dit wijzigt, werken ze niet meer. Daarom blijft het anker bewust staan als je een vraag anders formuleert.',
    },
} satisfies Translation<typeof en>;
